import React, { useEffect, useState, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getCompanyBookingSlots } from "../../actions/booking";
import moment from "moment";
import './companyServices.css';
import SunIcon from '../../asssets/icons/SunIcon.svg';
import MoonIcon from '../../asssets/icons/MoonIcon.svg';
import RisingSunIcon from '../../asssets/icons/RisingSunIcon.svg';
import { showModal, hideModal, setCurrentCompany } from '../../actions/waitlistModal';
import WaitlistModal from '../waitlist/WaitlistModal';
import BookingSlotTimeButton from './BookingSlotTimeButton';

const CompanyServices = ({
  company: { _id, services },
  getCompanyBookingSlots,
  booking: { bookingSlots },
  selectedService,
  selectedDate,
  calendarEvent,
  isSharing,
  reference,
  executeScrollForm,
  activeIndexdefault,
  setSelectedServiceIndex,
  appointmentDetail,
  handleAddToWaitlist,
  showModal, hideModal, setCurrentCompany, waitlistModal
}) => {
  const [activeIndex, setItem] = useState(
    appointmentDetail?.selectedServiceIndex
      ? appointmentDetail?.selectedServiceIndex
      : -1
  );
  const [selectedBookingSlot, setSelectedBookingSlot] = useState(null);

  useEffect(() => {
    setItem(
      appointmentDetail?.selectedServiceIndex
        ? appointmentDetail?.selectedServiceIndex
        : -1
    );
  }, [selectedDate, activeIndexdefault]);

  // Fetch booking slots when company or date changes
  useEffect(() => {
    if (_id && selectedDate?.selectedDate) {
      const dateString = moment(selectedDate.selectedDate).format('YYYY-MM-DD');
      getCompanyBookingSlots(_id, dateString);
    }
  }, [_id, selectedDate, getCompanyBookingSlots]);

  const [serviceFilter, setServiceFilter] = useState("");
  const [filteredServices, setFilteredServices] = useState({
    morning: [],
    afternoon: [],
    evening: []
  });

  // Categorize booking slots by time of day
  useEffect(() => {
    if (!bookingSlots || !Array.isArray(bookingSlots)) {
      setFilteredServices({ morning: [], afternoon: [], evening: [] });
      return;
    }

    // Filter by service name if serviceFilter is set
    let filteredSlots = bookingSlots;
    if (serviceFilter && serviceFilter !== "all") {
      filteredSlots = bookingSlots.filter(
        slot => slot.serviceInfo?.name === serviceFilter
      );
    }

    // Categorize slots by time of day
    const morning = [];
    const afternoon = [];
    const evening = [];

    filteredSlots.forEach((slot) => {
      // Double-check: Only show slots with status 'available'
      // Also check that slot has required data
      if (!slot || slot.status !== 'available' || !slot.serviceInfo) {
        return;
      }
      
      const startTime = moment(slot.start_time);
      const hour = startTime.hour();

      if (hour < 12) {
        morning.push(slot);
      } else if (hour < 17) {
        afternoon.push(slot);
      } else {
        evening.push(slot);
      }
    });

    setFilteredServices({ morning, afternoon, evening });
  }, [serviceFilter, bookingSlots, selectedDate]);

  const handleFilterChange = (e) => {
    e.preventDefault();
    setServiceFilter(e.target.value);
  };


  const handleCloseModal = () => {
    hideModal();
  };



  return (
    <div className="fnd-srch-in" ref={reference}>
      <div className="search-filter-bar mb-4">
        <div className="input-group">
          <select
            className="custom-select"
            onChange={(e) => handleFilterChange(e)}
          >
            <option value={""} defaultValue>
              Filter By A Service
            </option>
            <option value="all">All</option>
            {services.length > 0
              ? services.map((service) => {
                  return (
                    <Fragment key={service._id}>
                      <option value={service.name}>{service.name}</option>
                    </Fragment>
                  );
                })
              : "No service found"}
          </select>
        </div>
      </div>

      <div style={{ maxHeight: "calc(100vh - 15em)", overflow: "auto" }}>
        {/* Morning Section - Always Show */}
        <div className="time-category"> 
          <div className="horizontal-header-container morning-header">
            <div className="time-icon-container-horizontal">
              <img className='time-icon' src={RisingSunIcon} alt="Morning" />
            </div>
            <span className="time-label-horizontal">Morning</span>
            <div className="time-slot-color-horizontal morning-color-horizontal"></div>
          </div>
          <div className="time-slot-container service-list">
            {filteredServices.morning.length > 0 ? (
              filteredServices.morning.map((slot, index) => (
                <BookingSlotTimeButton
                  key={slot._id}
                  bookingSlot={slot}
                  serviceIndex={index}
                  selectedService={selectedService}
                  setItem={setItem}
                  setSelectedServiceIndex={setSelectedServiceIndex}
                  executeScrollForm={executeScrollForm}
                  activeIndex={activeIndex}
                  bookingItemTime={moment(slot.start_time)}
                  onSelect={(slot) => {
                    setSelectedBookingSlot(slot);
                    selectedService({
                      name: slot.serviceInfo.name,
                      service_duration: slot.serviceInfo.duration,
                      description: slot.serviceInfo.description,
                      price: slot.serviceInfo.price,
                      book_online: slot.serviceInfo.book_online || false,
                      call_to_book: slot.serviceInfo.call_to_book || false,
                      book_site: slot.serviceInfo.book_site || false,
                      book_site_link: slot.serviceInfo.book_site_link || "",
                      intakeForm: [],
                      start_time: slot.start_time,
                      date: slot.date,
                      _id: slot._id,
                      isBookingSlot: true,
                      bookingSlotId: slot._id,
                      companyId: slot.companyId,
                      serviceId: slot.serviceId
                    });
                  }}
                />
              ))
            ) : (
              <p className="text-muted">No Morning Slots Available</p>
            )}
          </div>
        </div>

        {/* Afternoon Section - Always Show */}
        <div className="time-category">
          <div className="horizontal-header-container afternoon-header">
            <div className="time-icon-container-horizontal">
              <img className='time-icon' src={SunIcon} alt="Afternoon" />
            </div>
            <span className="time-label-horizontal">Afternoon</span>
            <div className="time-slot-color-horizontal afternoon-color-horizontal"></div>
          </div>
          <div className="time-slot-container service-list">
            {filteredServices.afternoon.length > 0 ? (
              filteredServices.afternoon.map((slot, index) => {
                const adjustedIndex = filteredServices.morning.length + index;
                return (
                  <BookingSlotTimeButton
                    key={slot._id}
                    bookingSlot={slot}
                    serviceIndex={adjustedIndex}
                    selectedService={selectedService}
                    setItem={setItem}
                    setSelectedServiceIndex={setSelectedServiceIndex}
                    executeScrollForm={executeScrollForm}
                    activeIndex={activeIndex}
                    bookingItemTime={moment(slot.start_time)}
                    onSelect={(slot) => {
                      setSelectedBookingSlot(slot);
                      selectedService({
                        name: slot.serviceInfo.name,
                        service_duration: slot.serviceInfo.duration,
                        description: slot.serviceInfo.description,
                        price: slot.serviceInfo.price,
                        book_online: slot.serviceInfo.book_online || false,
                        call_to_book: slot.serviceInfo.call_to_book || false,
                        book_site: slot.serviceInfo.book_site || false,
                        book_site_link: slot.serviceInfo.book_site_link || "",
                        intakeForm: [],
                        start_time: slot.start_time,
                        date: slot.date,
                        _id: slot._id,
                        isBookingSlot: true,
                        bookingSlotId: slot._id,
                        companyId: slot.companyId,
                        serviceId: slot.serviceId
                      });
                    }}
                  />
                );
              })
            ) : (
              <p className="text-muted">No Afternoon Slots Available</p>
            )}
          </div>
        </div>

        {/* Evening Section - Always Show */}
        <div className="time-category">
          <div className="horizontal-header-container evening-header">
            <div className="time-icon-container-horizontal">
              <img className='time-icon' src={MoonIcon} alt="Evening" />
            </div>
            <span className="time-label-horizontal">Evening</span>
            <div className="time-slot-color-horizontal evening-color-horizontal"></div>
          </div>
          <div className="time-slot-container service-list">
            {filteredServices.evening.length > 0 ? (
              filteredServices.evening.map((slot, index) => {
                const adjustedIndex = filteredServices.morning.length + filteredServices.afternoon.length + index;
                return (
                  <BookingSlotTimeButton
                    key={slot._id}
                    bookingSlot={slot}
                    serviceIndex={adjustedIndex}
                    selectedService={selectedService}
                    setItem={setItem}
                    setSelectedServiceIndex={setSelectedServiceIndex}
                    executeScrollForm={executeScrollForm}
                    activeIndex={activeIndex}
                    bookingItemTime={moment(slot.start_time)}
                    onSelect={(slot) => {
                      setSelectedBookingSlot(slot);
                      selectedService({
                        name: slot.serviceInfo.name,
                        service_duration: slot.serviceInfo.duration,
                        description: slot.serviceInfo.description,
                        price: slot.serviceInfo.price,
                        book_online: slot.serviceInfo.book_online || false,
                        call_to_book: slot.serviceInfo.call_to_book || false,
                        book_site: slot.serviceInfo.book_site || false,
                        book_site_link: slot.serviceInfo.book_site_link || "",
                        intakeForm: [],
                        start_time: slot.start_time,
                        date: slot.date,
                        _id: slot._id,
                        isBookingSlot: true,
                        bookingSlotId: slot._id,
                        companyId: slot.companyId,
                        serviceId: slot.serviceId
                      });
                    }}
                  />
                );
              })
            ) : (
              <p className="text-muted">No Evening Slots Available</p>
            )}
          </div>
        </div>
      </div>
      <WaitlistModal
        show={waitlistModal.showModal}
        onHide={handleCloseModal}
        currentCompany={waitlistModal.currentCompany}
      />
    </div>
  );
};

CompanyServices.propTypes = {
  getCompanyBookingSlots: PropTypes.func.isRequired,
  booking: PropTypes.object.isRequired,
  // new props
  appointmentDetail: PropTypes.object,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  setCurrentCompany: PropTypes.func.isRequired,
  waitlistModal: PropTypes.object.isRequired,

};

const mapStateToProps = (state) => ({
  booking: state.booking,
  appointmentDetail: state.booking.appointmentDetail,
  waitlistModal: state.waitlistModal,
});

export default connect(mapStateToProps, { getCompanyBookingSlots, showModal, hideModal, setCurrentCompany })(CompanyServices);
